import React, { useEffect } from 'react';
import { useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Paper, Typography } from '@material-ui/core';
import { useForm } from "../../../../hooks/useForm";
import { CboProfesionales } from '../../../cbos/CboProfesionales';
import { Especialidad } from './Especialidad';

const useStyles = makeStyles({
    root: {
        padding:10,
        flexGrow: 1,
        marginTop:10,
    },
    input: {
        padding: 10,
    },
    grid: {
        padding: 10,
        marginBottom: 10,
        backgroundColor: 'white',
    },
    rootTitulo: {
        paddingLeft: 10,
        marginTop: 10,
        marginBottom: 10,
    },
});

const stateInitial = {
    idProfesional: null,
}

export const HomeParametrizacionSobreturnos = () => {
    const classes = useStyles();
    const { items } = useSelector((state) => state.efectoresP);
    const { centrosMedicos: centrosMedicosUsuario } = useSelector( state => state.auth );
    
    const [ efectorP, setEfectorP ] = React.useState();
    const [ formValues, handleInputChange ] = useForm(stateInitial);
    const { idProfesional } = formValues;

    useEffect(() => {
        setEfectorP( items.find(s => s.idEfectorRed === idProfesional) );
    }, [idProfesional, items]);

    return ( 
        <Grid container className={classes.root} justify="center" spacing={1}>  
            <Grid item xs={8}>
                <Grid container direction="row" alignItems="center">
                    <Grid item xs={12} md={6}>
                        <Paper className={classes.input}>
                            <CboProfesionales 
                                manejadorInputChange={handleInputChange}
                                filtrarPorUsuario={true}
                                valor={idProfesional}
                                autocomplete={true}
                            />
                        </Paper>
                    </Grid>
                </Grid>
            </Grid>
            {efectorP&&
                <Grid item xs={8} style={{marginTop: 10}}>
                    <Grid container direction="column">
                        {efectorP.efectorPCm.map( item =>  
                                <>
                                    {centrosMedicosUsuario.filter(i => i.idCentroMedico === item.idCentromedico).length>0&&
                                        <Grid item xs={12} md={6} className={classes.grid}>
                                            <Typography component="h3" variant="h5" className={classes.rootTitulo}>{item.centroMedico.descripcionCentro}</Typography>
                                            <Grid container direction="row" alignItems="center">
                                                <Grid item xs={8} ></Grid>
                                                <Grid item xs={4} style={{marginBottom: 5}}>Permite SobreTurnos</Grid>
                                                {efectorP.relEfectorPEspecialidad.map( i =>  
                                                    <Especialidad
                                                        descripcion={i.especialidad.descripcionEspecialidades}
                                                        idEspecialidad={i.idEspecialidad}
                                                        idProfesional={i.idEfectorRed}
                                                        idCentroMedico={item.idCentromedico}
                                                        seleccionado={
                                                            efectorP.configuracionSobreturnos
                                                                .filter(s => s.idCentroMedico === item.idCentromedico && s.idEspecialidad === i.idEspecialidad && !s.fechaBaja).length>0
                                                        }
                                                    />
                                                )}
                                            </Grid>
                                        </Grid>
                                    }
                                </>
                        )}
                    </Grid>
                </Grid>
            }
        </Grid> 
     );
}